"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mediaQueries", {
  enumerable: true,
  get: function get() {
    return _breakpoints.mediaQueries;
  }
});
Object.defineProperty(exports, "fontDefinitions", {
  enumerable: true,
  get: function get() {
    return _fontDefinitions.default;
  }
});
Object.defineProperty(exports, "lceReset", {
  enumerable: true,
  get: function get() {
    return _global.lceReset;
  }
});
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function get() {
    return _global.normalize;
  }
});
Object.defineProperty(exports, "lceGlobal", {
  enumerable: true,
  get: function get() {
    return _global.lceGlobal;
  }
});
exports.default = exports.theme = void 0;
var _breakpoints = require("./variables/breakpoints");
var _colors = require("./variables/colors");
var _fonts = require("./variables/fonts");
var _space = require("./variables/space");
var _layout = require("./variables/layout");
var _buttons = _interopRequireDefault(require("./components/buttons"));
var _badges = _interopRequireDefault(require("./components/badges"));
var _ctaButtons = _interopRequireDefault(require("./components/ctaButtons"));
var _cards = _interopRequireDefault(require("./components/cards"));
var _alerts = _interopRequireDefault(require("./components/alerts"));
var _links = _interopRequireDefault(require("./components/links"));
var _modals = _interopRequireDefault(require("./components/modals"));
var _dividers = _interopRequireDefault(require("./components/dividers"));
var _forms = _interopRequireDefault(require("./components/forms"));
var _text = _interopRequireDefault(require("./components/text"));
var _donut = _interopRequireDefault(require("./components/donut"));
var _skeletons = _interopRequireDefault(require("./components/skeletons"));
var _images = _interopRequireDefault(require("./components/images"));
var _progress = _interopRequireDefault(require("./components/progress"));
var _spinner = _interopRequireDefault(require("./components/spinner"));
var _fontDefinitions = _interopRequireDefault(require("./fontDefinitions"));
var _global = require("./global");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// components
var theme = {
  breakpoints: _breakpoints.breakpoints,
  colors: _colors.colors,
  ctaButtons: _ctaButtons.default,
  fonts: _fonts.fonts,
  fontSizes: _fonts.fontSizes,
  space: _space.space,
  media: _breakpoints.media,
  buttons: _buttons.default,
  badges: _badges.default,
  alerts: _alerts.default,
  forms: _forms.default,
  cards: _cards.default,
  links: _links.default,
  text: _text.default,
  skeletons: _skeletons.default,
  progress: _progress.default,
  modals: _modals.default,
  layout: _layout.layout,
  images: _images.default,
  donut: _donut.default,
  spinner: _spinner.default,
  styles: {
    root: {
      fontFamily: 'body',
      fontWeight: 'body'
    },
    hr: _dividers.default,
    a: _links.default.primary
  }
};
exports.theme = theme;
var _default = theme;
exports.default = _default;